class VariantPicker extends HTMLElement {
  connectedCallback() {
    this._handleOptionChange = this._handleOptionChange.bind(this);
    this.addEventListener("change", this._handleOptionChange);
  }

  disconnectedCallback() {
    this.removeEventListener("change", this._handleOptionChange);
  }

  _handleOptionChange(event) {
    event.stopPropagation();

    this.dispatchEvent(
      new CustomEvent("variant-picker:change", {
        detail: {
          variantID: event.target.dataset.variantId,
        },
        bubbles: true,
        composed: true,
      })
    );
  }
}

customElements.define("variant-picker", VariantPicker);
